import styled from 'styled-components';

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const StyledInput = styled.input`
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`;
const Error = styled.span`
  color: #ef4444;
  font-size: 12px;
`;

export default function Input({ label, error, ...props }) {
  return (
    <Field>
      {label && <label>{label}</label>}
      <StyledInput {...props} />
      {error && <Error>{error}</Error>}
    </Field>
  );
}
